import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  label: string;
  variant?: "default" | "danger";
}

const baseClass =
  "inline-flex items-center justify-center h-control w-control rounded-sm transition-colors duration-150 text-text-muted/60 hover:bg-surface-subtle/60 focus-visible:outline-none focus-visible:border-brand-primary/60 focus-visible:shadow-[0_0_0_2px_rgb(var(--brand-primary)/0.4)] border border-transparent";

const variants: Record<NonNullable<Props["variant"]>, string> = {
  default: "hover:text-brand-primary",
  danger: "hover:text-signal-error",
};

export const IconButton = forwardRef<HTMLButtonElement, Props>(function IconButton(
  { icon, label, variant = "default", className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      title={label}
      className={`${baseClass} ${variants[variant]} ${className ?? ""}`}
      {...rest}
    >
      <span className="material-symbols-outlined">{icon}</span>
    </button>
  );
});
